// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4463":"84676732","4468":"a2769aca","5562":"a2769aca"}[chunkId] + ".chunk.css";
};